export default __webpack_public_path__ + "static/media/background.8b8b980b.jpg";